import { useQuery } from '@tanstack/react-query';

import type { TQueryHookOptions } from '@/_state/apis/react-query-helpers';
import { customerPersistentRequest } from '@/_state/apis/react-query-helpers';
import type { FetchBaseQueryError } from '@/_state/apis/tanstack-api';
import { queryClient } from '@/_state/query-client';

import { customerTransformResponse } from './helper';
import type { TCustomerMeModel } from './model';

const meDependencyQueryKey = ['customerPersistentApi', 'meDependency'] as const;
const meDependencyPrefixKey = ['customerPersistentApi', 'meDependency'] as const;
type TMeDepPatch = { allow_rewards: boolean } | { image: string | null } | Record<string, unknown>;

export const useMeDependencyQuery = (options?: TQueryHookOptions<TCustomerMeModel>) => {
  return useQuery<TCustomerMeModel, FetchBaseQueryError>({
    queryKey: meDependencyQueryKey,
    queryFn: () =>
      customerPersistentRequest<TCustomerMeModel>('meDependency', 'me/', (response) =>
        customerTransformResponse(response as TCustomerMeModel)
      ),
    ...options,
    retry: false,
  });
};

export const invalidateMeDep = () => {
  void queryClient.invalidateQueries({ queryKey: meDependencyPrefixKey });
};

export const updateMeDep = (newData: TMeDepPatch) => {
  queryClient.setQueryData<TCustomerMeModel>(meDependencyQueryKey, (previous) => {
    if (!previous) {
      return previous;
    }

    return {
      ...previous,
      ...newData,
    } as TCustomerMeModel;
  });
};
